<script setup lang="ts">
import { cn } from '@/lib/cn';
import BaseCard from './BaseCard.vue';

defineProps<{
  label: string;
  value: string | number;
  sub?: string;
  class?: string;
}>();
</script>

<template>
  <BaseCard padding="md" :class="cn('flex flex-col gap-1', $props.class)">
    <div class="text-caption text-muted uppercase tracking-wide">{{ label }}</div>
    <!--
      Numerics rule from brief §12: every count/percentage/ID/time/money
      renders with `font-mono tabular-nums`. text-stat is 28/700/-0.025em.
    -->
    <div class="text-stat font-mono tabular-nums text-fg">{{ value }}</div>
    <div v-if="sub" class="text-caption text-muted">{{ sub }}</div>
  </BaseCard>
</template>
